import { getObjectWithoutFunctions } from "../../utils";
import { ShelvingStoreInterface } from "../useShelvingStore";
import { storeRoomInterface } from "../useStoreRoom";
import { useStoreSystemInterface } from "../useStoreSystem";

type StateForSaveT = {
    roomState: storeRoomInterface;
    shelvingState: ShelvingStoreInterface,
    configuratorState: useStoreSystemInterface
}

/**
 * Рекурсивно заменяет model на modelId в объектах, которые имеют bitrixId
 */
function replaceModelWithModelId(obj: any): any {
    if (!obj || typeof obj !== 'object') {
        return obj;
    }
    
    if (Array.isArray(obj)) {
        return obj.map(item => replaceModelWithModelId(item));
    }
    
    const updatedObj = { ...obj };
    
    // Если объект имеет model и modelId, сохраняем modelId и удаляем model URL
    if ('model' in updatedObj && 'modelId' in updatedObj && updatedObj.modelId) {
        // modelId уже есть, просто удаляем model URL
        delete updatedObj.model;
    }
    
    // Рекурсивно обрабатываем все свойства объекта
    for (const key in updatedObj) {
        if (updatedObj.hasOwnProperty(key)) {
            updatedObj[key] = replaceModelWithModelId(updatedObj[key]);
        }
    }
    
    return updatedObj;
}

export const getStateForSave = (
    roomState: storeRoomInterface,
    shelvingState: ShelvingStoreInterface,
    configuratorState: useStoreSystemInterface
): DeepPartial<StateForSaveT> => {
    const configuratorStateForSave = getObjectWithoutFunctions(configuratorState);
    delete (configuratorStateForSave as any).isWallsGreen;

    const baseState = {
        roomState: getObjectWithoutFunctions(roomState),
        shelvingState: getObjectWithoutFunctions(shelvingState),
        configuratorState: configuratorStateForSave,
    };
    
    // Заменяем model на modelId во всем состоянии
    return replaceModelWithModelId(baseState);
};
